import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useDeleteTemplateMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    isError,
  } = useMutation<unknown, Error, { companyId: string; templateId: string }>({
    mutationFn: ({ companyId, templateId }: { companyId: string; templateId: string }) =>
      api.delete(`admin/companies/${companyId}/data-export-templates/${templateId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin'] });
    },
  });

  const deleteTemplate = async (companyId: string, templateId: string) => {
    await mutateAsync({ companyId, templateId });
  };

  return {
    deleteTemplate,
    isLoading,
    isError,
  };
};
